import React, { useEffect } from "react";

interface IRedirectProps {
  to: string;
  forceReload?: boolean;
}

const Redirect: React.FC<IRedirectProps> = props => {
  const { to, forceReload } = props;

  useEffect(() => {
    if (forceReload) {
      window.location.href = to;
    }
  }, [forceReload, to]);

  return forceReload ? null : <Redirect to={to} />;
};

export default React.memo(Redirect);
